export const employeeAccessOptions = [
  {
    label: "Generate Bill",
    value: "generateBill",
    children: [
      {
        label: "Add Item",
        value: "addItem",
      },
      {
        label: "Advance Settings",
        value: "advanceSettings",
      },
      {
        label: "Bill Settings",
        value: "billSettings",
      },
      {
        label: "Edit Pricing",
        value: "editPricing",
      },
      {
        label: "Hold bill",
        value: "holdBill",
      },
      {
        label: "Discount",
        value: "discount",
      },
      {
        label: "Add Other Charges",
        value: "addOtherCharges",
      },
      {
        label: "Loyalty Redeem",
        value: "loyaltyRedeem",
      },
      {
        label: "Credit Sales",
        value: "creditSales",
      },
      {
        label: "Send Sms",
        value: "sendSms",
      },
    ],
  },
  {
    label: "Dashboard",
    value: "dashboard",
    children: [
      {
        label: "Return Item",
        value: "returnItem",
      },
      {
        label: "Reprint",
        value: "reprint",
      },
    ],
  },
  {
    label: "Shop Item",
    value: "shopItem",
    children: [
      {
        label: "Products",
        value: "products",
        children: [
          {
            label: "Create Product",
            value: "createProduct",
          },
          {
            label: "Edit Product",
            value: "editProduct",
          },
          {
            label: "Delete Product",
            value: "deleteProduct",
          },
        ],
      },
      {
        label: "Category",
        value: "category",
        children: [
          {
            label: "Create Category",
            value: "createCategory",
          },
          {
            label: "Edit Category",
            value: "editCategory",
          },
          {
            label: "Delete Category",
            value: "deleteCategory",
          },
        ],
      },
      {
        label: "Excel upload",
        value: "excelUpload",
      },
    ],
  },
  {
    label: "Tax Master",
    value: "taxMaster",
    children: [
      {
        label: "Custom Tax type",
        value: "customTaxType",
        children: [
          {
            label: "Create Custom Tax",
            value: "createCustomTax",
          },
          {
            label: "Edit Custom Tax",
            value: "editCustomTax",
          },
        ],
      },
      {
        label: "Create Tax",
        value: "createTax",
      },
      {
        label: "Edit Tax",
        value: "editTax",
      },
    ],
  },
  {
    label: "Reports",
    value: "reports",
    children: [
      {
        label: "Sales Report",
        value: "salesReport",
      },
      {
        label: "Profit and Loss",
        value: "profitAndLoss",
      },
      {
        label: "Stock Report",
        value: "stockReport",
      },
      {
        label: "Stock tracker",
        value: "stockTracker",
      },
    ],
  },
  {
    label: "Loyalty",
    value: "loyalty",
    children: [
      {
        label: "Add point",
        value: "addPoints",
      },
      {
        label: "Reports",
        value: "loyaltyReport",
      },
      {
        label: "Loyalty Configuration",
        value: "loyaltyConfiguration",
      },
    ],
  },
  {
    label: "Customer",
    value: "customer",
    children: [
      {
        label: "Outstanding",
        value: "outstanding",
        children: [
          {
            label: "View Outstanding",
            value: "viewOutstanding",
          },
          {
            label: "Clear Outstanding",
            value: "clearOutstanding",
          },
        ],
      },
      {
        label: "Update Alias",
        value: "updateAlias",
      },
      {
        label: "View Customer",
        value: "viewCustomer",
      },
    ],
  },
  {
    label: "Vendor",
    value: "vendor",
    children: [
      {
        label: "Create Vendor",
        value: "createVendor",
      },
      {
        label: "Edit Vendor",
        value: "editVendor",
      },
      {
        label: "Add bill",
        value: "addBill",
      },
      {
        label: "View Details",
        value: "viewDetails",
      },
      {
        label: "Add Product Items",
        value: "addProductItems",
      },
    ],
  },
  {
    label: "Expense",
    value: "expense",
    children: [
      {
        label: "View Expense",
        value: "createVendor",
      },
      {
        label: "Create Expense",
        value: "editVendor",
      },
      {
        label: "Delete Expense",
        value: "addBill",
      },
      {
        label: "Create Expense Type",
        value: "createExpenseType",
      },
    ],
  },
  {
    label: "Counter",
    value: "counter",
    children: [
      {
        label: "Create Expense",
        value: "addExpense",
      },
      {
        label: "View History",
        value: "viewHistory",
      },
    ],
  },
  {
    label: "Settings",
    value: "settings",
    children: [
      {
        label: "View Profile",
        value: "viewProfile",
      },
      {
        label: "Manage Outlet",
        value: "manageOutlet",
      },
      {
        label: "Invoice Customization",
        value: "invoiceCustomization",
      },
      {
        label: "Barcode Printer",
        value: "barcodePrinter",
      },
    ],
  },
];

export const DASHBOARDACCESS = ["returnItem", "reprint"];
export const PRODUCTACCESS = [
  "createProduct",
  "editProduct",
  "deleteProduct",
  "shopItem",
  "csvExport",
  "bulkUpdatePrice",
  "excelUpload",
  "taxMaster",
  "category",
  "products",
];
export const CATEGORYACCESS = [
  "createCategory",
  "editCategory",
  "deleteCategory",
];
export const TAXACCESS = [
  "createTax",
  "editTax",
  "customTaxType",
  "editCustomTax",
  "createCustomTax",
];
export const REPORTACCESS = [
  "salesReport",
  "profitAndLoss",
  "stockReport",
  "stockTracker",
  "reports",
];
export const LOYALTYACCESS = [
  "addPoints",
  "loyaltyReport",
  "loyaltyConfiguration",
  "loyalty",
];

export const CUSTOMERACCESS = [
  "outstanding",
  "updateAlias",
  "viewCustomer",
  "viewOutstanding",
  "clearOutstanding",
  "customerCsvExport",
  "customerViewAllBills",
  "viewAllBillsExport",
  "customer",
];

export const VENDORACCESS = [
  "createVendor",
  "editVendor",
  "addBill",
  "addProductItems",
  "viewDetails",
  "cancelBill",
  "vendor",
  "addBillVendor",
  "vendorViewDetails",
];

export const EXPENSEACCESS = [
  "createExpense",
  "editExpense",
  "deleteExpense",
  "createExpenseType",
  "expense",
  "expenseCSVExport",
];
export const COUNTERACCESS = [
  "addExpense",
  "viewHistory",
  "counterCSVExport",
  "historyCSVExport",
  "counter",
  "counterExpenses",
  "counterHistory",
];

export const SETTINGSACCESS = [
  "viewProfile",
  "invoiceCustomization",
  "barcodePrinter",
];

export const GENERATEBILLACCESS = [
  "generateBill",
  "addItem",
  "advanceSettings",
  "billSettings",
  "editPricing",
  "holdBill",
  "discount",
  "loyaltyRedeem",
  "creditSales",
  "sendSms",
  "b2bPricingAccess",
  "otherCharges",
  "otherAccess",
  "couponDiscount",
];
